import { createApi } from '@reduxjs/toolkit/query/react'

import { rtkBaseQuery } from '../../../../api'
import { providesList } from 'Utils/rtk-query'

export const flowsApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'flowsApi',
  tagTypes: ['BotFlows', 'FlowKBSections'],
  endpoints: (builder) => ({
    getBotFlows: builder.query({
      query: (data) => {
        const { botId, params } = data
        return {
          url: `v1/bot-profiles/${botId}/bot-flows/`,
          method: 'GET',
          params
        }
      },
      transformResponse: (response) => {
        const flows = response.results.map((result) => {
          if (!result.settings?.name) {
            result.settings.name = 'Default'
          }
          return result
        })
        return {
          results: flows,
          meta: response.meta
        }
      },
      providesTags: (response) => providesList(response.results, 'BotFlows')
    }),
    addBotFlow: builder.mutation({
      query: (data) => {
        const { id, name } = data
        return {
          url: `v1/bot-profiles/${id}/bot-flows/`,
          method: 'POST',
          body: { name }
        }
      },
      invalidatesTags: ['BotFlows']
    }),
    updateBot: builder.mutation({
      query: (data) => {
        const { botId, flowId, name } = data
        return {
          url: `v1/bot-profiles/${botId}/bot-flows/${flowId}`,
          method: 'PATCH',
          body: { name }
        }
      },
      invalidatesTags: ['BotFlows']
    }),
    getAllKbSections: builder.query({
      query: () => '/v1/kb/sections/all',
      providesTags: ['FlowKBSections']
    }),
    deleteBot: builder.mutation({
      query: (data) => {
        const { botId, flowId } = data
        return {
          url: `v1/bot-profiles/${botId}/bot-flows/${flowId}`,
          method: 'DELETE'
        }
      },
      invalidatesTags: ['BotFlows']
    })
  })
})

export const {
  useGetBotFlowsQuery,
  useAddBotFlowMutation,
  useUpdateBotMutation,
  useDeleteBotMutation,
  useGetAllKbSectionsQuery
} = flowsApi

export default flowsApi
